import { render, staticRenderFns } from "./NearbyAreas.vue?vue&type=template&id=614eaa12&scoped=true"
import script from "./NearbyAreas.vue?vue&type=script&lang=ts"
export * from "./NearbyAreas.vue?vue&type=script&lang=ts"
import style0 from "./NearbyAreas.vue?vue&type=style&index=0&id=614eaa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614eaa12",
  null
  
)

export default component.exports